import React from "react"
import { Card } from "frontend/components/layout"
import { Heading } from "frontend/components/text"
import { Button } from "frontend/components/interaction"
import t from "frontend/utils/translations"
import ErrorIcon from "./ErrorIcon"
import styles from "./UploadForm.module.css"

const ErrorDisplay = ({ message, filename, onRetry, onDelete }) => {
  return (
    <Card className={styles.container}>
      <div className={styles.formHeader}>
        <div className={`${styles.loadingContainer} ${styles.loadingContainerError}`}>
          <ErrorIcon />
        </div>
        <div className={styles.progressDetailsContainer}>
          <Heading size={4} className={styles.filename}>
            {filename}
          </Heading>
          <Heading size={6} className={`${styles.uploadProgress} ${styles.uploadError}`}>
            {message}
          </Heading>
        </div>
      </div>
      <div className={styles.errorButtonContainer}>
        <Button label={t("upload.form.dismiss")} onClick={onDelete} type="secondary" />
        <Button label={t("upload.form.buttons.retry")} onClick={onRetry} />
      </div>
    </Card>
  )
}

export default ErrorDisplay
